const TEMPLATING_SELECTION_UPDATED = (state, selection) => {
  state.selection = selection;
};
const TEMPLATING_SELECTED_DEFINITION_UPDATED = (state, selectedDefinition) => {
  state.selectedDefinition = selectedDefinition;
};

export default {
  TEMPLATING_SELECTION_UPDATED,
  TEMPLATING_SELECTED_DEFINITION_UPDATED,
};
